module.exports = __webpack_public_path__ + "img/law_thumbnail.28f4cb1d.jpg";